module.exports = __webpack_public_path__ + "1_0_64/img/key.3a25495d.png";